export default {
  GET_VIDEO_LIST: '/auth/introductionVideo/findList',
  // 增加视频点击量
  ADD_VIDEO_CLICK: '/auth/introductionVideo/findById',
  // 查询menu
  GET_WEBINAR_MENU: '/auth/dictionaries/findByParentId',
  GET_WEBINAR_LIST: '/auth/webinar/findList',
  GET_WEBINAR_DETAIL: '/auth/webinar/find',
  // 保存subscriber
  SAVE_SUBSCRIBER: '/auth/webinarSubscriber/save',
  GET_SUB_LIST: ''
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/introVideo.js